module.exports = __webpack_public_path__ + "static/media/yangvbakugo.11fca073.jpg";